/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactors_Factual2Inputs */

const id_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informasi Faktual:`)
};

const ms_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maklumat Faktual:`)
};

const da_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktuel Information:`)
};

const de_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sachliche Informationen:`)
};

const en_us2_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factual Information:`)
};

const es_es2_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información factual:`)
};

const es_mx2_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información factual:`)
};

const fil_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impormasyong Makatotohanan:`)
};

const fr_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations factuelles :`)
};

const it_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni fattuali:`)
};

const hu_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tényszerű információk:`)
};

const nl_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feitelijke informatie:`)
};

const no_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktisk informasjon:`)
};

const pl_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacje faktyczne:`)
};

const pt_br2_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações factuais:`)
};

const pt_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informação factual:`)
};

const ro_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informații faptice:`)
};

const fi_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktatieto:`)
};

const sv_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktisk information:`)
};

const vi_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin thực tế:`)
};

const tr_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek Bilgiler:`)
};

const cs_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faktické informace:`)
};

const bg_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фактическа информация:`)
};

const ru_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фактическая информация:`)
};

const uk_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фактична інформація:`)
};

const ar_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلومات واقعية:`)
};

const hi_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तथ्यात्मक जानकारी:`)
};

const th_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลข้อเท็จจริง:`)
};

const ja_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事実情報：`)
};

const zh_cn2_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事实性信息：`)
};

const zh_hant1_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事實性資訊：`)
};

const ko_about_fairusefactors_factual2 = /** @type {(inputs: About_Fairusefactors_Factual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사실적 정보:`)
};

/**
* | output |
* | --- |
* | "Factual Information:" |
*
* @param {About_Fairusefactors_Factual2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactors_factual2 = /** @type {((inputs?: About_Fairusefactors_Factual2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactors_Factual2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactors_factual2(inputs)
	if (locale === "ms") return ms_about_fairusefactors_factual2(inputs)
	if (locale === "da") return da_about_fairusefactors_factual2(inputs)
	if (locale === "de") return de_about_fairusefactors_factual2(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactors_factual2(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactors_factual2(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactors_factual2(inputs)
	if (locale === "fil") return fil_about_fairusefactors_factual2(inputs)
	if (locale === "fr") return fr_about_fairusefactors_factual2(inputs)
	if (locale === "it") return it_about_fairusefactors_factual2(inputs)
	if (locale === "hu") return hu_about_fairusefactors_factual2(inputs)
	if (locale === "nl") return nl_about_fairusefactors_factual2(inputs)
	if (locale === "no") return no_about_fairusefactors_factual2(inputs)
	if (locale === "pl") return pl_about_fairusefactors_factual2(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactors_factual2(inputs)
	if (locale === "pt") return pt_about_fairusefactors_factual2(inputs)
	if (locale === "ro") return ro_about_fairusefactors_factual2(inputs)
	if (locale === "fi") return fi_about_fairusefactors_factual2(inputs)
	if (locale === "sv") return sv_about_fairusefactors_factual2(inputs)
	if (locale === "vi") return vi_about_fairusefactors_factual2(inputs)
	if (locale === "tr") return tr_about_fairusefactors_factual2(inputs)
	if (locale === "cs") return cs_about_fairusefactors_factual2(inputs)
	if (locale === "bg") return bg_about_fairusefactors_factual2(inputs)
	if (locale === "ru") return ru_about_fairusefactors_factual2(inputs)
	if (locale === "uk") return uk_about_fairusefactors_factual2(inputs)
	if (locale === "ar") return ar_about_fairusefactors_factual2(inputs)
	if (locale === "hi") return hi_about_fairusefactors_factual2(inputs)
	if (locale === "th") return th_about_fairusefactors_factual2(inputs)
	if (locale === "ja") return ja_about_fairusefactors_factual2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactors_factual2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactors_factual2(inputs)
	return ko_about_fairusefactors_factual2(inputs)
});
export { about_fairusefactors_factual2 as "about.fairUseFactors.factual" }